import React, { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { loginUser } from "../loginSlice";
import { getDvSourceImageUrl } from "../../functions/themeAssets";
import "../fonts/breuer-headline.css";
import "../speakEasy.css";
import "./login.css";
import { setBackButtonUrl } from "../uiSlice";
import Swal from "sweetalert2";
import beginPlayImg from "../img/begin.png";

/** Landing page from old/index.php: theme logo + BEGIN PLAY -> rules. */
function Login() {
  const dispatch = useDispatch();
  const { status, user, error } = useSelector((state) => state.auth);
  const { status: themeStatus, data: themeData } = useSelector(
    (state) => state.theme
  );

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const isAdmin = searchParams.get("admin") === "true";

  useEffect(() => {
    dispatch(loginUser());
  }, [dispatch]);

  useEffect(() => {
    if (status === "succeeded" && user && isAdmin) {
      navigate("/admin");
    }
  }, [status, user, isAdmin, navigate]);

  useEffect(() => {
    if (status === "succeeded" && user?.backButtonRedirect) {
      dispatch(setBackButtonUrl(user.backButtonRedirect));
    }
  }, [status, user, dispatch]);

  useEffect(() => {
    const body = document.body;
    const keys = [
      "background-attachment",
      "background-size",
      "background-repeat",
      "background-position",
      "overflow-x",
      "margin",
      "padding",
      "height",
      "font-family",
      "backdrop-filter",
    ];
    const snapshot = keys.map((k) => [k, body.style.getPropertyValue(k)]);

    body.style.setProperty("background-attachment", "fixed");
    body.style.setProperty("background-size", "100% 100%");
    body.style.setProperty("background-repeat", "no-repeat");
    body.style.setProperty("background-position", "center");
    body.style.setProperty("overflow-x", "hidden");
    body.style.setProperty("margin", "0");
    body.style.setProperty("padding", "0");
    body.style.setProperty("height", "100vh");
    body.style.setProperty(
      "font-family",
      "'FiraSans-Medium', sans-serif",
      "important"
    );

    return () => {
      snapshot.forEach(([k, v]) => {
        if (v) body.style.setProperty(k, v);
        else body.style.removeProperty(k);
      });
    };
  }, []);

  useEffect(() => {
    if (status !== "failed") return;
    const msg = error ? String(error) : "Session expired";
    const redirect = user && user.backButtonRedirect ? user.backButtonRedirect : "/";
    Swal.fire("Session Expired!", msg, "error").then(() => {
      window.location.href = redirect;
    });
  }, [status, error, user]);

  if (status === "loading" || themeStatus === "loading") {
    return (
      <div className="login-main-container">
        <div className="quiz-loader-container">
          <div className="quiz-loader"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="login-main-container">
      {themeData?.logo && (
        <img
          src={getDvSourceImageUrl(themeData.logo)}
          className="login-logo1"
          alt="Game Logo"
        />
      )}
      {user && status === "succeeded" && (
        <button
          type="button"
          className="begin-play-btn"
          onClick={() => navigate("/rules")}
        >
          <img src={beginPlayImg} alt="Begin Play" className="begin-play-img" />
        </button>
      )}
      <div className="se-rotate-overlay" aria-hidden>
        Please rotate your device for the best experience
      </div>
    </div>
  );
}

export default Login;
